<template>
	<modal-container
		ref="modal"
		maxWidth="1400px"
	>
		<template
			:item="item"
			slot="modal-content"
			v-if="item"
		>
			<div class="extra-content flex">

				<div>
					<progressive-image
						:src="item.images.big"
						class="extra-img"
						:ratioWidth="1"
						:ratioHeight="2"
					/>
				</div>
				
				<div>
					<div class="extra-title">
						<h3>{{ item.title }}</h3>
					</div>

					<tags-line-orange
						:items="item.tags"
						class="section"
					/>

					<div class="section extra-description">
						{{ item.description }}
					</div>

					<div class="section"
						v-if="pavesiniExtrasId.includes(item.id) && !$mq.isDesktop()"
					>
						<router-link :to="{ name: 'pavesini' }" class="link-detail">
							Scopri di più
						</router-link>
					</div>

					<section-toggle
						:trigger.sync="showInfo"
						v-if="!$mq.isDesktop() && isToShowInfo(item)"
						class="section"
					>
						<template slot="title">
							<b>Informazioni aggiuntive</b>
						</template>

						<template slot="content" class="section">
							<div class="section" v-if='item.product.description' >
								<b>Ingredienti: </b>
								<span style='white-space: pre-wrap;'>{{ item.product.description }}</span>
							</div>

							<div class="section" v-if="item.product.allergens.length > 0">
								<b>Allergeni: </b>
								<div
									v-for="allergen, index in item.product.allergens"
									class="row-list"
								>
									{{ allergenName(allergen) }}</div>
							</div>

							<div class="section" v-if="item.product.nutrition && item.product.nutrition.calories">
								<div>
									<b>Kcal/Porzione: </b>
									<span>{{ item.product.nutrition.calories }} Kcal</span>
								</div>
							</div>

							<div class="section" v-if="item.product.weight">
								<b>Peso: </b>
								<span>{{ item.product.weight }} g.</span>
							</div>

							<div class="section" v-if="item.product.volume">
								<b>Volume: </b>
								<span>{{ item.product.volume }}</span>
							</div>
						</template>
					</section-toggle>

					<template class="section" v-if="$mq.isDesktop()">
						<div class="section" v-if='item.product.description'>
							<b>Ingredienti: </b>
							<span style='white-space: pre-wrap;'>{{ item.product.description }}</span>
						</div>

						<div class="section" v-if="item.product.allergens.length > 0">
							<b>Allergeni: </b>
							<div
								v-for="allergen, index in item.product.allergens"
								class="row-list"
							>
								{{ allergenName(allergen) }}</div>
						</div>

						<div class="section" v-if="pavesiniExtrasId.includes(item.id)">
							<router-link :to="{ name: 'pavesini' }" class="link-detail">
								Scopri di più
  							</router-link>
  						</div>

						<div class="section" v-if="item.product.nutrition && item.product.nutrition.calories">
							<div>
								<b>Kcal/Porzione: </b>
								<span>{{ item.product.nutrition.calories }} Kcal</span>
							</div>
						</div>

						<div class="section" v-if="item.product.weight">
							<b>Peso: </b>
							<span>{{ item.product.weight }} g.</span>
						</div>

						<div class="section" v-if="item.product.volume">
							<b>Volume: </b>
							<span>{{ item.product.volume }}</span>
						</div>

					</template>

					<div v-if="item.product.supplier.name" class="section">
						<img src="../../assets/img/supplier-icon.png" class="supplier-icon"> {{ item.product.supplier.name }}
					</div>
					
					<h3
						class="section extra-price"
					>
						{{ item.price | priceFilter }}
					</h3>

					<div v-if="!$_extraAction_extraAvailable(item)" class="section orange">
						ANDATO A RUBA :)
					</div>

					<div class="section extra-action" v-if="$_extraAction_extraAvailable(item) && action !== false">

						<template v-if="$_extraAction_quantityExtraInOrder(item.id) > 0">
							<div class="label">Quantità: </div>

							<div class="flex">
								<CTA
									:disabled="updating"
									@click="$_extraAction_remove(item)"
									:content="`-`"
								/>

								<div class="quantity-extra">
									{{ $_extraAction_quantityExtraInOrder(item.id) }}
								</div>

								<CTA
									:disabled="updating"
									@click="$_extraAction_add(item)"
									:content="`+`"
								/>
							</div>
						</template>

						<template v-else>
							<CTA
								class="full"
								:disabled="updating"
								@click="$_extraAction_add(item)"
								:content="$mq.isDesktop() ? $t('components.checkout.cart.edit.desktop') : $t('components.checkout.cart.edit.mobile')"
							/>
						</template>

					</div> 

					<div class="flash">
						<flash
							:flash="flash"
							:state="state"
						/>
					</div>
				</div>
			</div>
		</template>
	</modal-container>
</template>

<script>
import { extraAction } from '../../mixins/extraAction'
import TagsLineOrange from '../Parts/TagsLineOrange'
import SectionToggle from '../Parts/SectionToggle'
import Flash from '../Parts/Flash'

export default {

	data () {
		return {
			item: null,
			showInfo: false,

			flash: null,
			state: null,

			pavesiniExtrasId: [2464, 2465, 2466, 2461, 2460, 2454]
		}
	},

	mixins: [
		extraAction
	],

	components: {
		TagsLineOrange,
		SectionToggle,
		Flash
	},

	props: {
		action: {
			type: Boolean,
			default: true
		},
		order: {

		}
	},

	filters: {
		priceFilter (val) {
			return `€ ${val.replace('.', ',')}`
		}
	},

	methods: {
		isToShowInfo (item) {
			return item.product.description || item.product.allergens.length > 0 || (item.product.nutrition && item.product.nutrition.calories) || item.product.weight || item.product.volume
		},
		allergenName (allergen) {
			return this.$t('components.recipe.allergens.' + allergen.name.toLowerCase().replace(/\s+/g, '_'))
		},

		toggleSection () {
			this.showInfo = !this.showInfo
		},

		close () {
			this.$nextTick( () => {
				this.$refs.modal.close()
			})
		},

		open (extra) {
			this.item = extra
			this.$nextTick( () => {
				this.$refs.modal.open()
			})
		}
	}
}

</script>

<style scoped>
	h3 {
		text-align: left;
	}
	.orange {
		color: var(--quomi-orange);
	}

	.extra-title h3 {
		margin-bottom: 0;
		font-weight: bold;
	}

	.btn {
		margin: 0;
		border-radius: 4px;
	}

	.btn.full {
		width: 250px;
	}

	.row-list {
		display: inline-block;
	}

	.row-list:not(:last-child)::after {
		content: ', ';
		white-space: pre;
	}

	.section + .section {
		margin-top: 20px;
	}

	.info .section {
		margin-top: 20px;
	}

	.flash {
		height: 20px;
		margin-top: 5px;
	}

	.tags > span {
		background: orange;
		color: white;
		font-weight: bold;
		border-radius: 6px;
		padding: 0px 5px;
		margin-right: 10px;
		margin-top: 2px;
	}

	.flex > div {
		flex-basis: 50%;
		margin: 0 10px;
	}

	.extra-img {
		z-index: -1;
		padding-bottom: 0 !important;
	}

	.extra-img.image {
		height: 100%;
	}

	.extra-img.image >>> img {
		height: 100%;
	    width: auto;
	    max-width: inherit;
	    position: absolute;
	    left: 50%;
	    transform: translateX(-50%);
	    padding: 10px 0;
	}

	.extra-action {
		display: flex;
		flex-wrap: nowrap;
		font-weight: bold;
		align-items: center;
	}

	.extra-action .label {
		margin-right: 10px;
	}

	.extra-action .flex-right {
		display: flex;
	}

	.extra-action button {
		padding: 5px;
		background-color: var(--quomi-primary);
		color: white;
		border: 1.5px solid var(--quomi-primary);
	}

	.extra-action .btn:not(.full) {
		font-size: 18px;
		padding: 3px 20px;
	}

	.extra-action button.full {
		background-color: var(--quomi-primary);
		color: white;
	}

	.extra-action .quantity-extra {
		padding: 5px 20px;
		z-index: 1;
	}

	.extra-title {
		margin-top: 10px;
	}

	.extra-price {
		font-size: 22px;
		font-weight: bold;
	}

	.supplier-icon {
		width: 15px;
		padding-bottom: 3px;
	}

	@media (max-width: 700px) {
		.extra-content.flex {
			flex-direction: column;
		}
		.flex > div {
			flex-basis: 100%;
		}

		.extra-img.image {
			min-height: 200px;
			
		}

		.extra-img.image >>> img {
			padding: 0px 0;
		}
	}
</style>
